<div class="footer-container">
  @for (link of _links; track link.header) {
    <myre-layout-column [d]="[2]" [t]="[2]" [p]="[4]" class="footer-item">
      <h3 class="footer-item__header">{{ link.header }}</h3>
      @for (item of link.items; track item.name) {
        <myre-footer-url
          [url]="item.url"
          [value]="item.name"
          [target]="item.target"
          class="footer-link"
          (click)="_onItemClicked(item)"
        />
      }
    </myre-layout-column>
  }

  <myre-layout-column [d]="[4]">
    <myre-footer-image [imageUrl]="logoPath" class="copyright right" />

    <myre-footer-text
      [value]="_wordings._ui.footer.headline()"
      class="copyright right"
    />

    <myre-footer-text [value]="_copyright" class="copyright right" />

    <myre-dropdown
      class="lang"
      [(ngModel)]="_selectedLang"
      (ngModelChange)="_changeLanguage($event)"
      [list]="_languageList"
    />
  </myre-layout-column>
</div>
